import { getJsonMasters } from "common/functions/jsonMasters/common";
import { handleError } from "common/functions/utilities";
import { JsonMaster } from "common/interfaces/JsonMaster";
import { useEffect, useState } from "react";
import useSWR from "swr";

export const useStructureForPricingHooks = (
  setFatal: ((error?: string | null | undefined) => void) | undefined
) => {
  const jsonName = "structures";
  const [jsonMasters, setJsonMasters] = useState<JsonMaster[]>([]);

  const { data, error } = useSWR(jsonName, () => {
    if (jsonName) {
      return getJsonMasters<JsonMaster>(jsonName);
    }

    return [];
  });

  useEffect(() => {
    if (error) {
      handleError(error, setFatal, "選択肢を読み込めませんでした。");
    }
  }, [error, setFatal]);

  useEffect(() => {
    if (data) {
      const sanitizedData = data
        .map((item) => {
          switch (item.name) {
            case "木造（W）":
            case "鉄骨鉄筋コンクリート造（SRC）":
            case "鉄骨造（S）":
            case "鉄筋コンクリート造（RC）":
            case "その他":
              return item;
            case "コンクリートブロック造（RCB）":
              return {
                ...item,
                name: "コンクリートブロック造（CB）"
              } as JsonMaster;
          }

          return null;
        })
        .filter((item): item is JsonMaster => item !== null);

      sanitizedData.sort((a, b) => {
        const order = [
          "木造（W）",
          "鉄骨鉄筋コンクリート造（SRC）",
          "鉄筋コンクリート造（RC）",
          "鉄骨造（S）",
          "コンクリートブロック造（CB）",
          "その他"
        ];

        return order.indexOf(a.name!) - order.indexOf(b.name!);
      });

      setTimeout(() => setJsonMasters(sanitizedData), 0);
    }
  }, [data]);

  return { jsonMasters, setJsonMasters } as const;
};
